import React from "react"
import { Box, Heading, HStack, IconButton, Text } from "@chakra-ui/react"
import { createStandaloneToast } from '@chakra-ui/toast'
import { Icon } from "../@uikit"

const { toast } = createStandaloneToast()
const toast_id = "my-toaser"
export const toaster ={    
    error: (message, title = "") => {
        if (!toast.isActive(toast_id)) {        
            toast({
                render: () => {
                return (
                    <Box bg="red.500" shadow="sm" w="100%" px={5} py={3}   rounded="md" mb={1}  position="relative">
                        <HStack alignItems="flex-start">
                            <Box>
                                <Icon fontSize={25} name="error-warning-fill" color="whiteAlpha.800" />
                            </Box>
                            <Box flex={1} pt={2}>
                                {title && <Heading my={0} size="sm" color="whiteAlpha.700">{title}</Heading>}
                                <Text color="white" fontSize="sm">{message}</Text>
                            </Box>                            
                        </HStack>
                        <IconButton size="xs" colorScheme="red" rounded="full" variant="solid" position="absolute" right={2} top={2} icon={<Icon name="close-fill" color="currentcolor" />} />
                    </Box>
                )
                },   
                id: toast_id,         
                position: "top-right"
            })
        }
    },       
    success: (message) => {
        toast({
            render: () => {
              return (
                <Box bg="green.700"  bottom={0} shadow="md" w="100%" px="15px" py="8px"  rounded="md" mb={1}>
                    <Text color="white" fontSize="sm">{message}</Text>
                </Box>
              )
            },
            status: "success",
            placement: "top",
            duration: 3000
          })
    },
  };
